'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dId$0024 from "./presto.types$-Seed-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$55() {
  this.aGs = null;
  this.aGq = null;
  this.aGr = false;
  this.aGo = null;
  this.aGp = false;
  this.aGt = false;
  this.aGu = false;
  this.aGs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$55 as $c_Lpresto_CredentialsView$$anon$55 };
$p = $c_Lpresto_CredentialsView$$anon$55.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$55;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$55() {
}
export { $h_Lpresto_CredentialsView$$anon$55 as $h_Lpresto_CredentialsView$$anon$55 };
$h_Lpresto_CredentialsView$$anon$55.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aGs;
});
$p.t = (function() {
  if ((!this.aGr)) {
    this.aGq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGr = true;
  }
  return this.aGq;
});
$p.ae = (function() {
  if ((!this.aGp)) {
    this.aGo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSeed$002dId$0024.$m_Lpresto_types$SeedId$().cs8(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGp = true;
  }
  return this.aGo;
});
$p.w = (function() {
  if ((!this.aGu)) {
    this.aGt = false;
    this.aGu = true;
  }
  return this.aGt;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$55 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$55, "presto.CredentialsView$$anon$55", ({
  FX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$55 as $d_Lpresto_CredentialsView$$anon$55 };
//# sourceMappingURL=presto.-Credentials-View$$anon$55.js.map
